import { autoOnboardingApiUrl, autoOnboardingApiUrlV2 } from './constantsV2'
// @ts-ignore
import { getSession, apiReq } from './api'

const buildAutoOnboardingHeaders = () => {
  const session = getSession()
  return {
    Authorization: `Bearer ${session && session.accessToken}`,
  }
}

export function apiPostAutoOnboarding(endPoint: string, data?: unknown) {
  const url = autoOnboardingApiUrl + endPoint
  return apiReq(url, data, 'post', buildAutoOnboardingHeaders())
}

export function apiGetAutoOnboarding(endPoint: string, params?: unknown) {
  const url = autoOnboardingApiUrl + endPoint
  return apiReq(url, params, 'get', buildAutoOnboardingHeaders())
}

export function apiPutAutoOnboarding(
  endPoint: string,
  data?: unknown,
): Promise<{ message: string }> {
  const url = autoOnboardingApiUrl + endPoint
  return apiReq(url, data, 'put', buildAutoOnboardingHeaders())
}

export function apiPostAutoOnboardingV2(endPoint: string, data?: unknown): Promise<any> {
  const url = autoOnboardingApiUrlV2 + endPoint
  return apiReq(url, data, 'post', buildAutoOnboardingHeaders())
}

export function apiGetAutoOnboardingV2(endPoint: string, params?: unknown): Promise<any> {
  const url = autoOnboardingApiUrlV2 + endPoint
  return apiReq(url, params, 'get', buildAutoOnboardingHeaders())
}



// WEBPACK FOOTER //
// ./src/utils/apiV2.ts